import { decode, encode } from "base-64";

import "expo-router/entry";

// Polyfills for jsPDF in React Native

if (!global.btoa) {
  global.btoa = encode;
}

if (!global.atob) {
  global.atob = decode;
}
